import { render, staticRenderFns } from "./SupportForm.vue?vue&type=template&id=57e1a631&scoped=true&"
import script from "./SupportForm.vue?vue&type=script&lang=js&"
export * from "./SupportForm.vue?vue&type=script&lang=js&"
import style0 from "./SupportForm.vue?vue&type=style&index=0&id=57e1a631&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e1a631",
  null
  
)

export default component.exports